import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import "../../../shared/context/constructor.js";
import { ThisProvider } from "../../../shared/context/this.js";
import { Constructor } from "../../../shared/ui/constructor/Constructor.js";
import styles from "./ComparisonFooter.module.scss.js";
const ComparisonFooter = memo(function ComparisonFooter2({ items, layout, widgets }) {
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: styles.comparisonFooter, children: /* @__PURE__ */ jsx("div", { className: styles.comparisonFooter__row, children: items.map((item) => /* @__PURE__ */ jsx(ThisProvider, { data: item, children: /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, layout, widgets }) }, item.id)) }) });
});
export {
  ComparisonFooter
};
